import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { IMAGEMOTION_PACKAGES, WELCOME_CREDITS } from '@rehub/pricing';

const TESTER = IMAGEMOTION_PACKAGES.tester;

/**
 * How the welcome-credit sample works. Figures come from the shared
 * package catalogue so the entry page and sign-up dialog stay in step.
 */
export default function SampleVideoDisclosure({ idPrefix }: { idPrefix: string }) {
  const [open, setOpen] = useState(false);
  const buttonId = `${idPrefix}-sample-works`;
  const panelId = `${idPrefix}-sample-works-panel`;

  return (
    <div className="mx-auto mt-2 max-w-md text-left">
      <button
        id={buttonId}
        type="button"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((value) => !value)}
        className="mx-auto flex min-h-11 items-center justify-center gap-1.5 rounded-lg px-2 py-2 text-sm font-medium text-cyan-200 transition-colors hover:bg-white/5 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300 motion-reduce:transition-none"
      >
        How the free sample works
        <ChevronDown
          size={16}
          aria-hidden
          className={`shrink-0 transition-transform duration-200 motion-reduce:transition-none ${open ? 'rotate-180' : ''}`}
        />
      </button>
      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        hidden={!open}
        className="mt-1 rounded-lg border border-slate-600 bg-slate-950/70 px-3 py-3 text-sm leading-relaxed text-slate-100"
      >
        <p>New accounts receive {WELCOME_CREDITS} credits. The sample video uses {TESTER.credits} of them.</p>
        <p className="mt-1.5">
          Each account can create it once, with up to {TESTER.maxImages} photos and a small ImageMotion watermark.
          After that, videos use the paid packages.
        </p>
      </div>
    </div>
  );
}
